// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"928ad53f","239":"5b168099","667":"e41fceff"}[chunkId] + ".chunk.js";
};